module.exports = __webpack_public_path__ + "img/xc.c42087b6.png";